import React from 'react';

interface LinkedinIconProps {
  className?: string;
  color?: string;
  size?: number;
}

const LinkedinIcon: React.FC<LinkedinIconProps> = ({
  className = '',
  color = 'white',
  size = 24,
}) => {
  return (
    <svg
      viewBox="0 5 2490 2490.0000000000005"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      className={className}
      style={{ color }}
    >
      <path d="M185.2 313.1H2252V2291H185.2z" fill="#fff" />
      <path
        d="M0 183.4C0 84.9 82.4 5 184 5h2122c101.6 0 184 79.9 184 178.4v2133.3c0 98.5-82.4 178.3-184 178.3H184c-101.6 0-184-79.8-184-178.3z"
        fill="#0a66c2"
      />
      <path
        d="M756.7 2088.8v-1121H384.1v1121zm-186.2-1274c129.9 0 210.8-86.1 210.8-193.7-2.4-110-80.9-193.7-208.3-193.7-127.5 0-210.8 83.7-210.8 193.7 0 107.6 80.8 193.7 205.9 193.7zm392.4 1274h372.6v-626c0-33.5 2.4-67 12.3-90.9 26.9-67 88.2-136.3 191.2-136.3 134.8 0 188.7 102.8 188.7 253.5v599.6h372.6V1446c0-344.3-183.8-504.5-428.9-504.5-201 0-289.2 112.3-338.3 188.8h2.5V967.8H962.9c4.9 105.2 0 1121 0 1121z"
        fill="#fff"
      />
    </svg>
  );
};

export default LinkedinIcon;
